import React from "react";
import { Navigate } from "react-router-dom";

import { useContext } from "react";
import { AuthContext } from "../context/AuthContext";

const roleMap = {
  1: "admin",
  2: "company",
  3: "employee",
  4: "agent",
  5: "retailer",
  6: "retailer_user",
  7: "customer",
};


export default function RoleRoute({ allowedRoles, children }) {
  const { user: authUser } = useContext(AuthContext);

  if (!authUser) return <Navigate to="/login" replace />;

  const userRole = Number(authUser.role);
  const userRoleStr = roleMap[userRole];
  const isVerifiedStep = Number(authUser.is_verified || 0);
  const userType = authUser.type_of_user;

  // -------------------------------
  // 🔒 FORCE ONBOARDING UNTIL STEP 5 COMPLETE
  // -------------------------------
  const onboardingRequired = [2, 4, 5].includes(userRole) && isVerifiedStep < 7;

  if (onboardingRequired && window.location.pathname !== "/onboard") {
    return <Navigate to="/onboard" replace />;
  }

  // Prevent navigating back to onboarding if completed
  if (!onboardingRequired && window.location.pathname === "/onboard") {
    return <Navigate to="/" replace />;
  }

  // -------------------------------
  // ROLE BASED ACCESS CHECK
  // -------------------------------
  if (allowedRoles.includes(userRoleStr)) {
    return children;
  }

  // -------------------------------
  // DEFAULT REDIRECT BASED ON ROLE
  // -------------------------------
  let redirectPath = "/login";

  if (userRole === 3 && userType === "Operation") {
    redirectPath = "/oprdashboard";
  } else {
    switch (userRole) {
      case 1:
        redirectPath = "/superdashboard";
        break;
      case 2:
        redirectPath = "/dashboard";
        break;
      case 3:
        redirectPath = "/empdashboard";
        break;
      case 4:
        redirectPath = "/agentdashboard";
        break;
      case 5:
        redirectPath = "/retailerdashboard";
        break;
      case 6:
        redirectPath = "/userdashboard";
        break;
      default:
        redirectPath = "/login";
    }
  }

  return <Navigate to={redirectPath} replace />;
}



// import React from "react";
// import { Navigate } from "react-router-dom";

// const roleMap = {
//   1: "admin",
//   2: "company",
//   3: "agent",
//   4: "employee",
//   5: "retailer",
//   6: "customer",
// };

// export default function RoleRoute({ allowedRoles, children }) {
//   const authUser = JSON.parse(localStorage.getItem("authUserData"));

//   if (!authUser) return <Navigate to="/login" replace />;

//   const userRole = Number(authUser.role);
//   const userRoleStr = roleMap[userRole];

//   // Redirect unverified users (roles 2,4,5)
//   if ([2, 4, 5].includes(userRole) && authUser.is_verified === null) {
//     if (window.location.pathname !== "/onboard") {
//       return <Navigate to="/onboard" replace />;
//     }
//   }


//   // Allow access if role matches
//   if (allowedRoles.includes(userRoleStr)) {
//     return children;
//   }

//   // Redirect to default dashboard based on role
//   let redirectPath = "/login";
//   switch (userRole) {
//     case 1: redirectPath = "/superdashboard"; break;
//     case 2: redirectPath = "/dashboard"; break;
//     case 3: redirectPath = "/agentdashboard"; break;
//     case 4: redirectPath = "/empdashboard"; break;
//     case 5: redirectPath = "/retailerdashboard"; break;
//     default: redirectPath = "/login";
//   }

//   return <Navigate to={redirectPath} replace />;
// }



// import React from "react";
// import { Navigate } from "react-router-dom";

// export default function RoleRoute({ allowedRoles, children }) {
//   const authUser = JSON.parse(localStorage.getItem("authUserData"));

//   if (!authUser) return <Navigate to="/login" replace />;

//   // Get numeric role from the stored user object
//   const userRole = Number(authUser.role);

//   // Allow access if the role matches
//   if (allowedRoles.includes(userRole)) {
//     return children;
//   }

//   // Redirect user to correct dashboard based on role
//   let redirectPath = "/login";
//   switch (userRole) {
//     case 1:
//       redirectPath = "/superdashboard"; // admin
//       break;
//     case 2:
//       redirectPath = "/dashboard";      // company
//       break;
//     case 3:
//       redirectPath = "/agentdashboard"; // agent
//       break;
//     case 4:
//       redirectPath = "/empdashboard";   // employee
//       break;
//     case 5:
//       redirectPath = "/retailerdashboard"; // retailer
//       break;
//     default:
//       redirectPath = "/login";
//   }

//   return <Navigate to={redirectPath} replace />;
// }



// import React from "react";
// import { Navigate } from "react-router-dom";

// export default function RoleRoute({ allowedRoles, children }) {
//   const authUser = JSON.parse(localStorage.getItem("authUserData"));

//   if (!authUser) return <Navigate to="/login" replace />;

//   //  ✔ Get the role we stored during login (company/agent/retailer)
//   const userRole = localStorage.getItem("userRole");

//   //  ✔ Allow access if the role matches
//   if (allowedRoles.includes(userRole)) {
//     return children;
//   }

//   //  ✔ Redirect user to correct dashboard
//   const redirectPath =
//     userRole === "admin"
//       ? "/superdashboard"
//       : userRole === "company"
//       ? "/dashboard"
//       : userRole === "agent"
//       ? "/agentdashboard"
//       : userRole === "retailer"
//       ? "/retailerdashboard"
//       : "/login";

//   return <Navigate to={redirectPath} replace />;
// }


// import React from "react";
// import { Navigate } from "react-router-dom";

// export default function RoleRoute({ allowedRoles, children }) {
//   const authUser = JSON.parse(localStorage.getItem("authUserData"));

//   if (!authUser) return <Navigate to="/login" replace />;

//   const userRole = authUser?.type;

//   // If allowed → show page
//   if (allowedRoles.includes(userRole)) {
//     return children;
//   }

//   // Else → redirect user to their correct dashboard
//   const redirectPath =
//     userRole === "admin"
//       ? "/superdashboard"
//       : userRole === "company"
//       ? "/dashboard"
//       : userRole === "agent"
//       ? "/agentdashboard"
//       : userRole === "retailer-user"
//       ? "/custdashboard"
//       : "/login";

//   return <Navigate to={redirectPath} replace />;
// }
